<template>
  <div>
    <div id="dropdown" />
    <div class="relative">
      <!-- Mobile top bar with hamburger -->
      <div class="md:hidden fixed top-0 left-0 right-0 z-30 flex items-center justify-between bg-white border-b border-gray-100 px-4 py-3 shadow-sm">
        <Link href="/" class="flex items-center">
          <logo class="fill-white" width="100" height="40" />
        </Link>
        <button
          class="w-10 h-10 rounded-xl bg-gray-50 hover:bg-orange-50 flex items-center justify-center text-gray-500 hover:text-orange-500 transition-colors"
          @click="$refs.mainMenu.openMobile()"
        >
          <i class="material-icons-outlined" style="font-size:22px;">menu</i>
        </button>
      </div>

      <!-- Spacer for mobile top bar -->
      <div class="md:hidden h-14" />

      <div class="md:flex md:flex-col">
        <div class="md:flex md:flex-col md:h-screen">
          <div class="md:flex md:flex-shrink-0">
            <!-- Desktop top logo bar -->
            <div class="hidden md:flex items-center justify-center bg-white border-b border-gray-100 md:flex-shrink-0 md:w-56 p-4">
              <Link class="mt-1 mb-1" href="/">
                <logo class="fill-white" width="120" height="50" />
              </Link>
            </div>

            <div
              class="md:text-md flex items-center justify-between p-4 w-full text-sm bg-white border-b md:px-12 md:py-0"
            >
              <div class="flex items-center gap-3">
                <Link href="/version" class="flex items-center px-3 py-1 text-xs font-bold text-gray-600 transition-colors bg-gray-100 rounded-md hover:bg-gray-200">
                  v{{ $page.props.appVersion }}
                </Link>

                <Link :href="auth.user.account.custom_rates ? '/taxes' : '#'" class="hidden items-center px-3 py-1 text-xs font-semibold text-green-700 transition-colors bg-green-100 rounded-md md:flex hover:bg-green-200">
                  1$ = {{ change }} BsD
                </Link>
              </div>
              <div class="font-semibold text-xl" />
              <dropdown class="mt-1" placement="bottom-end">
                <template #default>
                  <div class="group flex items-center gap-3 cursor-pointer select-none">
                    <!-- Logo empresa / Fallback icono -->
                    <div class="w-9 h-9 rounded-xl flex-shrink-0 overflow-hidden border border-gray-100 shadow-sm bg-gray-50 flex items-center justify-center">
                      <img
                        v-if="auth.user.account.logo"
                        :src="auth.user.account.logo"
                        :alt="auth.user.account.name"
                        class="w-full h-full object-contain p-0.5"
                      />
                      <i v-else class="material-icons-outlined text-gray-400" style="font-size: 20px;">business</i>
                    </div>

                    <div class="mr-1 text-gray-700 group-hover:text-blue-600 focus:text-blue-600 whitespace-nowrap">
                      <span class="font-medium">{{ auth.user.first_name }}</span>
                      <span class="hidden md:inline">&nbsp;{{ auth.user.last_name }}</span>
                      <div class="text-xs text-gray-400">
                        {{ auth.user.account.plan_name }}
                      </div>
                    </div>
                    <icon
                      class="w-4 h-4 fill-gray-400 group-hover:fill-blue-600 focus:fill-blue-600"
                      name="cheveron-down"
                    />
                  </div>
                </template>
                <template #dropdown>
                  <div class="mt-2 py-2 text-sm bg-white rounded shadow-xl">
                    <Link
                      class="block px-6 py-2 hover:text-white hover:bg-blue-500"
                      :href="`/account/${auth.user?.account?.id}?mode=perfil`"
                    >
                      Mi perfil
                    </Link>
                    <Link
                      v-if="auth.user.role === 'admin'" class="block px-6 py-2 hover:text-white hover:bg-blue-500"
                      :href="`/account/${auth.user?.account?.id}?mode=mi-suscripcion`"
                    >
                      Mi Suscripción
                    </Link>
                    <Link
                      v-if="auth.user.role === 'admin' && auth.user.account.plan !== 'free'"
                      class="block px-6 py-2 hover:text-white hover:bg-blue-500" :href="`/account/${auth.user?.account?.id}?mode=panel-usuarios`"
                    >
                      Usuarios
                    </Link>
                    <Link
                      v-if="auth.user.role === 'admin'" class="block px-6 py-2 hover:text-white hover:bg-blue-500"
                      :href="`/account/${auth.user?.account?.id}?mode=informacion-general`"
                    >
                      Cuenta
                    </Link>
                    <Link
                      class="block px-6 py-2 w-full text-left hover:text-white hover:bg-blue-500" href="/logout"
                      method="delete" as="button"
                    >
                      Cerrar sesión
                    </Link>
                  </div>
                </template>
              </dropdown>
            </div>
          </div>
          <div class="md:flex md:flex-grow md:overflow-hidden">
            <main-menu
              ref="mainMenu" :account="auth.user.account"
              class="flex-shrink-0 md:w-56 md:overflow-y-auto bg-[#e2e2e2]"
            />
            <div class="px-4 py-8 md:flex-1 md:p-12 md:overflow-y-auto isolate" scroll-region>
              <flash-messages />
              <slot />



              <!-- Haz un footer donde coloques los links de ayuda y los terminos y condiciones-->
              <footer class="mt-12 pt-8 border-t border-gray-200">
                <div class="flex flex-col md:flex-row justify-between items-center gap-4">
                  <div class="text-sm text-gray-600">
                    © {{ new Date().getFullYear() }} Realgestión. Todos los derechos reservados.
                  </div>
                  <div class="flex flex-wrap gap-6">
                    <Link
                      href="https://wa.me/584244010195?text=Hola, necesito ayuda con el sistema de Realgestión"
                      class="text-sm text-gray-600 hover:text-blue-600 transition-colors"
                    >
                      Centro de Ayuda
                    </Link>
                    <Link href="/terms" class="text-sm text-gray-600 hover:text-blue-600 transition-colors">
                      Términos y Condiciones
                    </Link>
                    <Link href="/privacy" class="text-sm text-gray-600 hover:text-blue-600 transition-colors">
                      Política de Privacidad
                    </Link>
                  </div>
                </div>
              </footer>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import Logo from '@/Shared/Logo'
import Dropdown from '@/Shared/Dropdown'
import MainMenu from '@/Shared/MainMenu'
import FlashMessages from '@/Shared/FlashMessages'
import BottomMenu from './BottomMenu.vue'
import '@n8n/chat/style.css'
import { createChat } from '@n8n/chat'

export default {
  components: {
    Dropdown,
    FlashMessages,
    Icon,
    Link,
    Logo,
    MainMenu,
    BottomMenu,
  },
  props: {
    auth: Object,
    change: String,
    appVersion: String, // Add this prop
  },
  data() {
    return {
      date: '',
      time: '',
      mobileMenuOpen: false,
    }
  },
  watch: {
    '$page.url'() {
      this.closeMobileMenu()
    },
  },
  mounted() {
    // Mostrar mensajes flash como toasts
    if (this.$page.props.flash.success) {
      this.$toast.success(this.$page.props.flash.success)
    }
    if (this.$page.props.flash.error) {
      this.$toast.error(this.$page.props.flash.error)
    }
    if (this.$page.props.flash.warning) {
      this.$toast.warning(this.$page.props.flash.warning)
    }
    if (this.$page.props.flash.info) {
      this.$toast.info(this.$page.props.flash.info)
    }
  },
  methods: {
    closeMobileMenu() {
      this.mobileMenuOpen = false
    },
    zeroPadding: (num, digit) => {
      var zero = ''
      for (var i = 0; i < digit; i++) {
        zero += '0'
      }
      return (zero + num).slice(-digit)
    },
    update: () => {
      let cd = new Date()
      let hours = ''
      let minutes = ''
      let secounds = ''
      let zero = ''

      for (let i = 0; i < 1; i++) {
        zero += '0'
      }
      hours = cd.getHours() > 9 ? cd.getHours() : (zero + cd.getHours())
      minutes = cd.getMinutes() > 9 ? cd.getMinutes() : (zero + cd.getMinutes())
      secounds = cd.getSeconds() > 9 ? cd.getSeconds() : (zero + cd.getSeconds())

      return hours + ':' + minutes + ':' + secounds
    },
  },
}
</script>

<style scoped>
.background {
  background-color: #bbe8e1;
}
</style>
